export const STORE = 'ORGANIZATION_INFO';
export const SET_ORGANIZATION_INFO = 'SET_ORGANIZATION_INFO';
export const GET_ORGANIZATION_INFO = 'GET_ORGANIZATION_INFO';
export const EMIT_ORGANIZATION_INFO = 'EMIT_ORGANIZATION_INFO';
export const SET_ORGANIZATIONS_INFO = 'SET_ORGANIZATIONS_INFO';
export const GET_ORGANIZATIONS_INFO = 'GET_ORGANIZATIONS_INFO';
